/**
 * Lightweight GA4 Click Tracking Utility
 * Usage:
 * <button data-ga4="signup_click">Sign Up</button>
 * <button data-ga4="add_to_cart" data-ga4-params='{"product_id": "123"}'>Add to Cart</button>
 */

(function() {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  const throttleMap = new WeakMap();
  const THROTTLE_DELAY = 1000;

  function isThrottled(element) {
    const lastClick = throttleMap.get(element);
    const now = Date.now();
    if (lastClick && now - lastClick < THROTTLE_DELAY) {
      return true;
    }
    throttleMap.set(element, now);
    return false;
  }

  function getElementText(element) {
    return (element.textContent || element.innerText || '').trim();
  }

  function parseParams(paramsString) {
    try {
      return JSON.parse(paramsString);
    } catch (e) {
      console.warn('GA4 Tracking: Invalid JSON in data-ga4-params:', paramsString);
      return {};
    }
  }

  function trackEvent(element) {
    const eventName = element.getAttribute('data-ga4');
    if (!eventName) {
      return;
    }
    if (isThrottled(element)) {
      return;
    }
    const params = {
      element_text: getElementText(element),
      page_location: window.location.href,
    };
    const customParams = element.getAttribute('data-ga4-params');
    if (customParams) {
      Object.assign(params, parseParams(customParams));
    }
    const eventData = {
      event: eventName,
      ...params
    };
    console.log('GA4 Tracking: Event fired', eventData);
    window.dataLayer.push(eventData);
  }

  function handleClick(event) {
    const target = event.target.closest('[data-ga4]');
    if (target) {
      trackEvent(target);
    }
  }

  document.addEventListener('click', handleClick, true);
})();
